<script lang="ts">
	import type { CurrencyRange } from 'utility/search-fields'
	import type { ComponentProps } from 'svelte'
	import type { i18n } from 'types/common'

	import Pin from 'components/search/Pin.svelte'
	import CurrencyInput from '@isoftdata/svelte-currency-input'
	import { getContext } from 'svelte'

	interface Props extends Omit<ComponentProps<typeof CurrencyInput>, 'value' | 'change'> {
		label: string
		from?: string
		to?: string
		disabled?: boolean
		isPinned?: boolean
		change?: (value: CurrencyRange) => void
	}

	let {
		//
		label,
		from = $bindable(''),
		to = $bindable(''),
		disabled = false,
		isPinned = false,
		change,
		...rest
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<label
	for="currencyRangeFrom"
	class="col-form-label pb-0"
	>{label} <Pin {isPinned} />
</label>
<div class="row">
	<div class="col-12 col-md-6">
		<CurrencyInput
			{...rest}
			{disabled}
			id="currencyRangeFrom"
			label={translate('common:from', 'From')}
			bind:value={from}
			change={() => {
				if (from && (!to || parseFloat(to) === 0)) {
					to = from
				}
				change?.({ from, to })
			}}
		></CurrencyInput>
	</div>
	<div class="col-12 col-md-6">
		<CurrencyInput
			{...rest}
			{disabled}
			label={translate('common:to', 'To')}
			bind:value={to}
			change={() => change?.({ from, to })}
		></CurrencyInput>
	</div>
</div>
